import { ProColumns } from '@ant-design/pro-components';
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable';
import { SearchModel } from 'pages/model';
import React, { useState, Dispatch, SetStateAction } from 'react'
import { ListCustomerCriteria } from 'services/Main/customerSegment_services';
import { customerSegmentStore } from 'stores/root_store';
import { formatNumber } from 'utils/formatHelper';

type PropsTableList = {
  data: ListCustomerCriteria[];
  dataSearch: SearchModel;
  handleSearchList: Dispatch<SetStateAction<SearchModel>>
  getDataListCustomer: (data: SearchModel) => Promise<void>
};


const columnsDefault: ProColumns<ListCustomerCriteria>[] = [
  // stt
  // {
  //   title: 'STT',
  //   dataIndex: 'stt',
  //   width: 50,
  //   key: 'stt',
  //   className: '!rounded-none !py-1',
  //   align: 'center',
  // },
  // Mã CRM khách hàng
  {
    title: 'Mã CRM khách hàng',
    dataIndex: 'crmCode',
    width: 100,
    key: 'crmCode',
    className: '!rounded-none !py-1',
  },
  // Mã SAP khách hàng
  {
    title: 'Mã SAP khách hàng',
    dataIndex: 'sapCode',
    width: 100,
    key: 'sapCode',
    className: '!rounded-none !py-1',
  },
  // Tên khách
  {
    title: 'Tên khách',
    dataIndex: 'customerName',
    width: 200,
    ellipsis: true,
    key: 'customerName',
    className: '!rounded-none !py-1',
  },
  // Địa chỉ
  {
    title: 'Địa chỉ',
    dataIndex: 'address',
    width: 200,
    ellipsis: true,
    key: 'address',
    className: '!rounded-none !py-1',

  },
  // Nhân viên Admin
  {
    title: 'Nhân viên Admin',
    dataIndex: 'customerAdmin',
    width: 150,
    key: 'customerAdmin',
    className: '!rounded-none !py-1',
  },
  // Nhân viên kinh doanh
  {
    title: 'Nhân viên kinh doanh',
    dataIndex: 'customerSales',
    width: 150,
    ellipsis: true,
    key: 'customerSales',
    className: '!rounded-none !py-1',
  },
  // Hệ thống showroom (Đếm số lượng)
  {
    title: 'Hệ thống showroom',
    dataIndex: 'quantityShowroom',
    width: 100,
    key: 'quantityShowroom',
    className: '!rounded-none !py-1',
    render: (text) => <div className="!text-right">{text}</div>,
  },
  // Giá trị điểm trưng bày
  {
    title: 'Giá trị điểm trưng bày',
    dataIndex: 'gtdtb',
    width: 120,
    key: 'gtdtb',
    className: '!rounded-none !py-1',
    render: (text, record) => <div className="!text-right">{formatNumber(record.gtdtb, 0)}</div>,
  },
  // Số lượng nhân sự của công ty
  {
    title: 'Số lượng nhân sự của công ty',
    dataIndex: 'quantityEmployee',
    width: 100,
    key: 'quantityEmployee',
    className: '!rounded-none !py-1',
    render: (text, record) => <div className="!text-right">{text}</div>,

  },
  // Tỉ lệ lãi gộp
  {
    title: 'Tỉ lệ lãi gộp',
    dataIndex: 'tiLeLaiGop',
    width: 100,
    key: 'tiLeLaiGop',
    className: '!rounded-none !py-1',
    render: (text, record) => <div className="!text-right">{formatNumber(record.tiLeLaiGop, 2)}%</div>,
  },
  // Khu vực (Bắc, Trung, Nam)
  {
    title: 'Khu vực',
    dataIndex: 'area',
    width: 150,
    key: 'area',
    ellipsis: true,
    className: '!rounded-none !py-1',
  },
  // Tỉnh/Thành phố
  {
    title: 'Tỉnh/Thành phố',
    dataIndex: 'province',
    width: 100,
    key: 'province',
    className: '!rounded-none !py-1',
  },
  // Quận/Huyện
  {
    title: 'Quận/Huyện',
    dataIndex: 'district',
    width: 150,
    ellipsis: true,
    key: 'district',
    className: '!rounded-none !py-1',
  },
  // Doanh số
  {
    title: 'Doanh số',
    dataIndex: 'revenue',
    width: 150,
    key: 'revenue',
    className: '!rounded-none !py-1',
    render: (text, record) => <div className="!text-right">{record.revenue ? formatNumber(record.revenue, 0) : 0}</div>,
  },
  // Tăng trưởng doanh số (Cùng kỳ)
  {
    title: 'Tăng trưởng doanh số (Cùng kỳ)',
    dataIndex: 'increaseRevenue',
    width: 150,
    key: 'increaseRevenue',
    className: '!rounded-none !py-1',
    render: (text, record) => {
      return (
        <div className="!text-right">{formatNumber(record.increaseRevenue, 2)}%</div>
      )
    }
  },
  // Tăng trưởng doanh số (Kỳ trước)
  {
    title: 'Tăng trưởng doanh số (Kỳ trước)',
    dataIndex: 'increaseRevenuePreviousPeriod',
    width: 150,
    key: 'increaseRevenuePreviousPeriod',
    className: '!rounded-none !py-1',
    render: (text, record) => {
      return (
        <div className="!text-right">{formatNumber(record.increaseRevenuePreviousPeriod, 2)}%</div>
      )
    }
  },
  // Mức tin dùng sản phẩm AC
  {
    title: 'Mức tin dùng sản phẩm AC',
    dataIndex: 'productLevel',
    width: 100,
    key: 'productLevel',
    className: '!rounded-none !py-1',
  },
  // Mức tương tác
  {
    title: 'Mức tương tác',
    dataIndex: 'interaction',
    width: 100,
    key: 'interaction',
    className: '!rounded-none !py-1',
  },
  // Số năm mua hàng
  {
    title: 'Số năm mua hàng',
    dataIndex: 'numberPurchase',
    width: 100,
    key: 'numberPurchase',
    className: '!rounded-none !py-1',
    render: (text) => <div className="!text-right">{text}</div>,
  },
  // Nhóm hàng mua nhiều (SAP)
  {
    title: 'Nhóm hàng mua nhiều (SAP)',
    dataIndex: 'buyingGroupALot',
    width: 100,
    key: 'buyingGroupALot',
    className: '!rounded-none !py-1',
  },
  // Số tháng chưa mua hàng (Tính từ đơn hàng gần nhất)
  {
    title: 'Số tháng chưa mua hàng (Tính từ đơn hàng gần nhất)',
    dataIndex: 'timeNotPurchased',
    width: 150,
    key: 'timeNotPurchased',
    className: '!rounded-none !py-1',
    render: (text) => <div className="!text-right">{text}</div>,
  },
];
const TableListCount = ({ data, dataSearch, handleSearchList, getDataListCustomer }: PropsTableList) => {
  // Custom default columns table with resizeable
  const [columns, setColumn] = useState<ProColumns<ListCustomerCriteria>[]>(columnsDefault);
  const [loadingTable, setLoadingTable] = useState(false)
  // Function handle resize columns
  const handleResize =
    (index: number) =>
      (e: any, { size }: any) => {
        // Set columns
        setColumn((prevColumns) => {
          const nextColumns = [...prevColumns];
          nextColumns[index] = {
            ...nextColumns[index],
            width: size.width,
          };
          return nextColumns;
        });
      };

  return (
    <CustomProTable<ListCustomerCriteria>
      columns={columns}
      handleResize={handleResize}
      rowKey="crmCode"
      bordered
      search={false}
      dataSource={data}
      scroll={{ x: 3500, y: 450 }}
      options={false}
      loading={loadingTable}
      pagination={{
        // ...tablePagination(dataSearch, handleSearchList),
        position: ["topRight"],
        pageSizeOptions: [10, 20, 50, 100],
        defaultPageSize: 10,
        onChange: async (page, pageSize) => {
          setLoadingTable(true)
          await getDataListCustomer({
            ...dataSearch,
            paging: {
              pageSize: pageSize,
              pageIndex: page
            }
          })

          handleSearchList({
            ...dataSearch,
            paging: {
              pageSize: pageSize,
              pageIndex: page
            }
          })
          setLoadingTable(false)
        },
        total: customerSegmentStore.listCustomerCriteria.paging?.totalCount,
      }}
    />
  );
};

export default TableListCount